import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { FieldsetModule } from 'primeng/fieldset';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputMaskModule } from 'primeng/inputmask';
import { InputTextModule } from 'primeng/inputtext';
import { ListboxModule } from 'primeng/listbox';
import { MegaMenuModule } from 'primeng/megamenu';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { PanelModule } from 'primeng/panel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ScrollTopModule } from 'primeng/scrolltop';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TableModule } from 'primeng/table';

import { TieredMenuModule } from 'primeng/tieredmenu';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToastModule } from 'primeng/toast';
import { NgxSpinnerModule } from "ngx-spinner";
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from '../interceptors/auth.interceptor';
import { ImageDefaultDirective } from './directives/image-default.directive';
import { MessageService } from 'primeng/api';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { SkeletonModule } from 'primeng/skeleton';
import { StopClickPropagationDirective } from './directives/stop-click-propagation.directive';
import { MessageModule } from 'primeng/message';
import { ConfirmationService } from 'primeng/api';
import { DividerModule } from 'primeng/divider';
import { DataViewModule } from 'primeng/dataview';
import { ChartModule } from 'primeng/chart';
import { KeyFilterModule } from 'primeng/keyfilter';
import { FileUploadModule } from 'primeng/fileupload';
import { FleetFilterComponent } from './fleet-filter/fleet-filter.component';
import { FleetFilterDatepickerComponent } from './fleet-filter-datepicker/fleet-filter-datepicker.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { TagModule } from 'primeng/tag';
import { BadgeModule } from 'primeng/badge';
import { CustomSearchPipe } from './custom-filter/custom-filter-pipe';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { MultiSelectModule } from 'primeng/multiselect';

// ------------- NEW IMPORTS ------------- //
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectModule } from 'primeng/select';
import { PopoverModule } from 'primeng/popover';
import { TabsModule } from 'primeng/tabs';
import { TextareaModule } from 'primeng/textarea';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { ImageModule } from 'primeng/image';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ListboxModule,
    NgbModule
  ],
  declarations: [
    ImageDefaultDirective,
    StopClickPropagationDirective,
    FleetFilterComponent,
    FleetFilterDatepickerComponent,
    CustomSearchPipe
  ],
  exports: [
    AccordionModule,
    FormsModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    ButtonModule,
    CheckboxModule,
    ConfirmDialogModule,
    ConfirmPopupModule,
    DialogModule,
    DynamicDialogModule,
    FieldsetModule,
    InputNumberModule,
    InputMaskModule,
    InputTextModule,
    ListboxModule,
    MegaMenuModule,
    MenuModule,
    MenubarModule,
    PanelModule,
    RadioButtonModule,
    RatingModule,
    RippleModule,
    ScrollPanelModule,
    ScrollTopModule,
    SelectButtonModule,
    SplitButtonModule,
    TableModule,
    TieredMenuModule,
    ToggleButtonModule,
    ToastModule,
    NgxSpinnerModule,
    CardModule,
    ImageDefaultDirective,
    ToolbarModule,
    TooltipModule,
    SkeletonModule,
    MessageModule,
    DividerModule,
    DataViewModule,
    ChartModule,
    FleetFilterComponent,
    BreadcrumbModule,
    FleetFilterDatepickerComponent,
    KeyFilterModule,
    TagModule,
    FileUploadModule,
    BadgeModule,
    CustomSearchPipe,
    InputGroupModule,
    InputGroupAddonModule,
    MultiSelectModule,
    ToggleSwitchModule,
    DatePickerModule,
    SelectModule,
    PopoverModule,
    TabsModule,
    TextareaModule,
    IconFieldModule,
    InputIconModule,
    ImageModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    MessageService, ConfirmationService
  ]
})
export class SharedModule { }
